import { atom } from "jotai/vanilla";

/** Hidden storage for cursors, since we can not store all of them in the URL */
export const cursorStoreAtom = atom<Map<string, string[]>>(new Map());
